// =============================================================================
// faq-content.ts — Foire aux questions FIXE plateforme de la page « Informations générales sur le
// référencement » (DBU §3.3, enrichissement §3.3). Contenu STATIQUE, indépendant de toute campagne.
// =============================================================================
// Comme briefing-content.ts (modalités de participation), ce contenu est INVARIANT et ne dépend
// d'aucune donnée serveur : il répond aux questions récurrentes des fournisseurs. Chaque réponse est
// ANCRÉE dans la source normative (DBU §3.1/§3.3/§3.5/§3.6, §1.4.1/§1.4.7) — aucune règle inventée.
// Rédaction sans em-dash de substitution parenthétique (invariant éditorial #6).

/** Une entrée de FAQ (§3.3) : question + réponse ancrée DBU + référence de source (traçabilité). */
export interface FaqEntry {
  readonly id: string;
  readonly question: string;
  /** Libellé COURT du sommaire (colonne de gauche / scrollspy) — voir redesign GATE_HUMAN 2026-09-12. */
  readonly shortLabel: string;
  readonly answer: string;
  /** Référence de source normative (affichée en discret, traçabilité éditoriale). */
  readonly source: string;
}

/** Les questions récurrentes des fournisseurs, ancrées dans le DBU (aucune clause inventée). */
export const FAQ_ENTRIES: readonly FaqEntry[] = [
  {
    id: 'confidentialite',
    question: 'Mes tarifs sont-ils visibles par les autres fournisseurs ?',
    shortLabel: 'Tarifs visibles par les autres ?',
    answer:
      'Non. Vos saisies sont cloisonnées et ne sont jamais visibles d’un autre fournisseur. Les analyses de marché sont anonymisées avant toute restitution, et aucune donnée nominative n’est diffusée aux tiers.',
    source: 'DBU §1.4.1, §3.5',
  },
  {
    id: 'echeance',
    question: 'Que se passe-t-il si je ne soumets pas avant l’échéance du cycle ?',
    shortLabel: 'Pas de soumission avant l’échéance ?',
    answer:
      'À la date de clôture programmée, la saisie est verrouillée de manière définitive et plus aucune modification n’est possible. Une absence de soumission formelle entraîne l’exclusion de vos TJM du référencement pour ce cycle.',
    source: 'DBU §3.3, §3.5',
  },
  {
    id: 'sauvegarde',
    question: 'Mes saisies sont-elles enregistrées automatiquement ?',
    shortLabel: 'Enregistrement automatique ?',
    answer:
      'Oui. Le brouillon est enregistré silencieusement toutes les 2 minutes et à chaque perte de focus (tabulation, clic ailleurs). La dernière sauvegarde est indiquée en bas de la grille. Un bouton « Sauvegarder » permet aussi un enregistrement immédiat.',
    source: 'DBU §3.5, §1.4.7',
  },
  {
    id: 'modification-post-soumission',
    question: 'Puis-je modifier mes tarifs après les avoir soumis ?',
    shortLabel: 'Modifier après soumission ?',
    answer:
      'Oui, tant que la date d’échéance du cycle n’est pas atteinte. Le bouton « Modifier mes tarifs » rouvre votre saisie en édition avec vos valeurs déjà soumises. Toute resoumission remplace intégralement la version précédente pour ce cycle.',
    source: 'DBU §3.5',
  },
  {
    id: 'cycle-2',
    question: 'Qu’est-ce que le Cycle 2 ?',
    shortLabel: 'Qu’est-ce que le Cycle 2 ?',
    answer:
      'Le Cycle 2 rouvre la saisie après validation du Cycle 1 par l’administrateur. Vos TJM du Cycle 1 y sont rappelés en lecture seule, et un indicateur de positionnement comparatif anonymisé devient visible. Une absence de modification vaut reconduction des valeurs du Cycle 1, sous réserve de soumettre le Cycle 2 avant l’échéance.',
    source: 'DBU §3.5, §3.6',
  },
  {
    id: 'collaborateurs',
    question: 'Plusieurs collaborateurs de mon établissement peuvent-ils saisir ?',
    shortLabel: 'Plusieurs collaborateurs ?',
    answer:
      'Oui. Plusieurs contacts d’un même SIRET peuvent contribuer, mais pas en parallèle sur le même profil : un profil en cours d’édition est temporairement marqué et verrouillé pour les autres contacts. La dernière valeur enregistrée fait foi, et la soumission peut être effectuée par tout contact ayant signé les CGU.',
    source: 'DBU §3.5',
  },
];
